import React from "react";
import { MdEmail } from "react-icons/md";
import {
  FaPhoneAlt,
  FaFacebookF,
  FaTwitter,
  FaPinterestP,
  FaInstagram,
} from "react-icons/fa";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

function SocialHeader() {
  return (
    <div className="social-Info py-2">
      <Container>
        <Row>
          <Col md={9}>
            <div className="social-one d-flex gap-5">
              <p>
                <MdEmail className="mx-2 align-middle" />
                Email: contact@bcastudy.com
              </p>
              <p>
                <FaPhoneAlt className="mx-2 " style={{ fontSize: "12px" }} />
                Phone: +7788664422
              </p>
            </div>
          </Col>
          <Col md={3}>
            <div className="social-two gap-3">
              <Link>
                <FaFacebookF />
              </Link>
              <Link>
                <FaTwitter />
              </Link>
              <Link>
                <FaPinterestP />
              </Link>
              <Link>
                <FaInstagram />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SocialHeader;
